export default "__VITE_ASSET__zEQVROJXQ2oFT2lc4JnEpw__";